import { useState, useRef } from 'react';

export const useOtpInput = (length: number = 4) => {
  const [otp, setOtp] = useState<string[]>(new Array(length).fill(""));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  const handleInputChange = (value: string, index: number) => {
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, length);
    const newOtp = [...otp];
    for (let i = 0; i < pasteData.length; i++) {
        if (i < length) {
            newOtp[i] = pasteData[i];
        }
    }
    setOtp(newOtp);
    const focusIndex = Math.min(pasteData.length, length - 1);
    inputRefs.current[focusIndex]?.focus();
  };

  const handleFocus = (index: number) => {
    inputRefs.current[index]?.select();
  };

  const clear = () => {
    setOtp(new Array(length).fill(""));
    inputRefs.current[0]?.focus();
  };

  const otpValue = otp.join("");

  return {
    otp,
    inputRefs,
    handleInputChange,
    handleKeyDown,
    handlePaste,
    handleFocus,
    otpValue,
    clear,
  };
};
